export const SUPPORTED_LOCALES = ["de-DE", "en-US"] as const;
export const DEFAULT_LOCALE = "en-US";
export const COUNTRY_COOKIE_NAME = "user-country";
export const LOCALE_NAMES = {
    "de-DE": "German",
    "en-US": "English",
};
